import { Component, h } from 'preact';
import { Listing, ReqState, ListResponse } from '../../../../../types';
import { InqPropertyCard } from '../propcard/inq-property-card.component';
import { InquiryLoadingMessage, InquiryLoadFailureMessage } from './loaders';

interface InquiryDetailsPropertyListProps {
  listings: ListResponse<Listing>;
  reqState: ReqState;
}

export class InquiryDetailsPropertyList extends Component<InquiryDetailsPropertyListProps> {
  render(props: InquiryDetailsPropertyListProps) {
    if (props.reqState === ReqState.IN_PROGRESS) {
      return <InquiryLoadingMessage message='Loading selected properties...' />
    } else if (props.reqState === ReqState.FAILED) {
      return <InquiryLoadFailureMessage message='Could not load selected properties' />
    }

    const listings = props.listings.results;

    if (listings && listings.length > 0) {
      return (
        <div className="hi-inqdetails__selected-properties">
          { listings.map(listing =>
            <InqPropertyCard listing={ listing }
              inDetailsCard={ true }
              key={ listing.propertyKey } />
          ) }
        </div>
      );
    } else {
      return <p>No selected properties.</p>
    }
  }
}